import { useEffect, useState } from "react";
import Header from "./Header";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./Login";
import Register from "./Register";
import Cookies from "js-cookie";
import  Homee  from "./Homee";
import Escprofile from "./Escprofile";
import Review from "./Review";
import Edit from "./Edit";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!Cookies.get('authToken'));

  useEffect(() => {
    // Update state when cookies change - if you want, you can listen for cookie changes here or on login/logout
    setIsLoggedIn(!!Cookies.get('authToken'));
  }, []);

  //reading cookie

//   const userCookie = Cookies.get("user");
// if (userCookie) {
//   const user = JSON.parse(userCookie);
//   console.log("User info:", user);
// }

  return (
    <Router>
      {/* Pass isLoggedIn and setIsLoggedIn as props */}
      <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
      <Routes>
        <Route path="/" element={<Homee />} />
        <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/user/:id" element={<Escprofile />} />  
        <Route path="/review/:id" element={<Review />} />  
        <Route path="/edit-review/:escortId/:reviewId" element={<Edit />} />  
        </Routes>
    </Router>
  );
}

export default App;



// pip freeze > requirements.txt

//Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass

//npm start

